import VolunteerForm from '@/components/forms/VolunteerForm';
import SectionHeader from '@/components/shared/SectionHeader';
import { motion } from 'framer-motion';
import { HeartHandshake, Users, ShieldCheck } from 'lucide-react';

const VolunteerCTASection = () => {
    return (
        <section
            className="section-pad bg-[hsl(var(--secondary))]/60 relative overflow-hidden"
            data-testid="home-volunteer-section"
        >
            <div className="absolute inset-0 grain-bg opacity-60 pointer-events-none" />
            <div className="container-page relative grid lg:grid-cols-12 gap-10 items-start">
                <motion.div
                    initial={{ opacity: 0, y: 10 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5 }}
                    viewport={{ once: true, margin: '-60px' }}
                    className="lg:col-span-5"
                >
                    <SectionHeader
                        eyebrow="Volunteer With Us"
                        title="Join 3,400+ changemakers on the ground."
                        description="Whether you can give an hour a week or a full day a month — we'll match you to a program that fits."
                    />
                    <ul className="mt-6 space-y-3 text-sm text-foreground/80">
                        <li className="flex items-start gap-2">
                            <Users className="h-4 w-4 mt-0.5 text-[hsl(var(--accent))]" />
                            Structured onboarding and mentor pairing.
                        </li>
                        <li className="flex items-start gap-2">
                            <HeartHandshake className="h-4 w-4 mt-0.5 text-[hsl(var(--accent))]" />
                            Volunteer hours certificate on completion.
                        </li>
                        <li className="flex items-start gap-2">
                            <ShieldCheck className="h-4 w-4 mt-0.5 text-[hsl(var(--accent))]" />
                            Safe, respectful and inclusive environment.
                        </li>
                    </ul>
                </motion.div>
                <motion.div
                    initial={{ opacity: 0, y: 12 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5, delay: 0.1 }}
                    viewport={{ once: true, margin: '-60px' }}
                    className="lg:col-span-7"
                >
                    <VolunteerForm compact />
                </motion.div>
            </div>
        </section>
    );
};

export default VolunteerCTASection;
